"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconTravelLuggage1 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconTravelLuggage1, _Icon);
  function IconTravelLuggage1(props) {
    var _this;
    _classCallCheck(this, IconTravelLuggage1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconTravelLuggage1).call(this, props));
    _this.name = 'IconTravelLuggage1';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "travel-luggage-1_svg__group0"
    }, _react2.default.createElement("path", {
      className: "travel-luggage-1_svg__path0",
      d: "M9.077 23.666a.486.486 0 01-.127-.017 11.743 11.743 0 01-1.488-.495 11.927 11.927 0 01-5.335-4.279.472.472 0 01-.071-.101 12.176 12.176 0 01-1.123-2.079A11.924 11.924 0 01.884 7.51 11.967 11.967 0 0112.01.044c1.552 0 3.072.299 4.518.889a11.955 11.955 0 017.467 11.108.5.5 0 01-1 0 10.942 10.942 0 00-2.948-7.5h-5.591c-.965 0-1.75.785-1.75 1.75s.785 1.75 1.75 1.75h.432a3.51 3.51 0 012.841 1.455.5.5 0 01-.812.584 2.505 2.505 0 00-2.029-1.039h-.432c-1.516 0-2.75-1.234-2.75-2.75s1.234-2.75 2.75-2.75h4.524a11.029 11.029 0 00-2.83-1.682 10.91 10.91 0 00-4.141-.815 10.97 10.97 0 00-10.2 6.845 11.305 11.305 0 00-.526 1.652h5.469c.935 0 1.815.364 2.476 1.026l.024.024a3.864 3.864 0 01.872 4.124l-.252.653a4.946 4.946 0 01-3.785 3.083l-2.698.45a10.98 10.98 0 005.814 3.783.498.498 0 01-.126.982zM1.096 10.541a10.953 10.953 0 00.759 5.767c.245.582.542 1.148.887 1.685l3.181-.53a3.94 3.94 0 003.016-2.457l.252-.653a2.861 2.861 0 00-.645-3.055l-.024-.024a2.482 2.482 0 00-1.769-.734H1.096z"
    }), _react2.default.createElement("path", {
      className: "travel-luggage-1_svg__path1",
      d: "M13.745 24.041a2.754 2.754 0 01-2.75-2.75v-3.5a2.754 2.754 0 012.75-2.75h.25v-.5c0-1.378 1.122-2.5 2.5-2.5h2c1.378 0 2.5 1.122 2.5 2.5v.5h.25a2.754 2.754 0 012.75 2.75v3.5a2.754 2.754 0 01-2.75 2.75h-7.5zm7.5-1c.965 0 1.75-.785 1.75-1.75v-3.5c0-.965-.785-1.75-1.75-1.75h-1.25v7h1.25zm-2.25 0v-7h-3v7h3zm-5.25-7c-.965 0-1.75.785-1.75 1.75v3.5c0 .965.785 1.75 1.75 1.75h1.25v-7h-1.25zm6.25-1v-.5c0-.827-.673-1.5-1.5-1.5h-2c-.827 0-1.5.673-1.5 1.5v.5h5z"
    })));
    return _this;
  }
  return IconTravelLuggage1;
}(_Icon3.default);
exports.default = IconTravelLuggage1;